import { useMemo } from 'react';
import cn from 'classnames';
import { Button, Card, Column, Row, Typography } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { Intent } from "../../../../../../infra/access-control";
import { utils } from "../../../../../../utils";
import { makeSectionsFromServices } from "../../../../PackagesStep/makeSectionsFromServices";
import { BillingSection } from "./BillingSection";
import styles from "./PackageCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetPackageCardTID = parentTestId => getTestIds({
  parentTestId
});
export const PackageCard = _ref => {
  let {
    package: pkg,
    isSelected,
    isEffectiveDateInFuture,
    canSelect,
    onSelect,
    testId,
    disabled,
    style
  } = _ref;
  const {
    PackageCardTestIds
  } = useMemo(() => GetPackageCardTID(testId), [testId]);
  const sections = useMemo(() => makeSectionsFromServices(pkg.services, {
    isEffectiveDateInFuture
  }), [pkg.services, isEffectiveDateInFuture]);
  const oneTimeSections = sections.filter(s => s.category === 'oneTime');
  const recurringSections = sections.filter(s => s.category === 'recurring');
  const variableSections = sections.filter(s => s.category === 'variable');
  const optionalSection = sections.find(s => s.category === 'optional');
  const handleCardClick = () => {
    if (!isSelected && !disabled) {
      onSelect();
    }
  };
  return /*#__PURE__*/_jsx(Card, {
    className: cn(styles.packageCard, {
      [styles.selected]: isSelected,
      [styles.disabled]: disabled && !isSelected
    }),
    testId: PackageCardTestIds.Root(),
    "data-bundleid": pkg.id,
    onClick: handleCardClick,
    role: "button",
    tabIndex: disabled ? -1 : 0,
    onKeyDown: e => {
      if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
        e.preventDefault();
        handleCardClick();
      }
    },
    style: style,
    children: /*#__PURE__*/_jsxs(Column, {
      className: styles.cardContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        className: styles.packageName,
        testId: PackageCardTestIds.Title(),
        children: pkg.name
      }), /*#__PURE__*/_jsxs(Column, {
        className: styles.sectionsContainer,
        testId: PackageCardTestIds.SectionsContainer(),
        children: [oneTimeSections.map(section => /*#__PURE__*/_jsx(BillingSection, {
          title: section.sum ? utils.formatDollarAmount(section.sum) : undefined,
          subtitle: section.subtitle,
          services: section.services,
          hasOptionalServices: section.hasOptionalServices,
          testId: "".concat(testId, "-section-").concat(section.id)
        }, section.id)), recurringSections.map(section => /*#__PURE__*/_jsx(BillingSection, {
          title: section.sum ? utils.formatDollarAmount(section.sum) : undefined,
          subtitle: section.subtitle,
          services: section.services,
          hasOptionalServices: section.hasOptionalServices,
          testId: "".concat(testId, "-section-").concat(section.id)
        }, section.id)), variableSections.map(section => /*#__PURE__*/_jsx(BillingSection, {
          title: "Variable",
          services: section.services,
          testId: "".concat(testId, "-section-").concat(section.id)
        }, section.id)), optionalSection && optionalSection.services.length > 0 && /*#__PURE__*/_jsx(BillingSection, {
          title: "Optional services",
          services: optionalSection.services,
          isOptional: true,
          testId: "".concat(testId, "-section-optional")
        })]
      }), /*#__PURE__*/_jsx(Row, {
        className: styles.bottomArea,
        children: isSelected ? /*#__PURE__*/_jsxs(Row, {
          className: styles.selectedIndicator,
          testId: PackageCardTestIds.SelectedIndicator(),
          children: [/*#__PURE__*/_jsx(Checkmark, {}), /*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            className: styles.selectedLabel,
            children: "Selected"
          })]
        }) : canSelect ? /*#__PURE__*/_jsx(Button, {
          intent: Intent.SelectPackage,
          skin: "primaryOutlineOpaque",
          onClick: e => {
            e.stopPropagation();
            onSelect();
          },
          className: styles.selectButton,
          testId: PackageCardTestIds.SelectButton(),
          disabled: disabled,
          children: "Select"
        }) : /*#__PURE__*/_jsx(Button, {
          skin: "primaryOutlineOpaque",
          onClick: e => {
            e.stopPropagation();
            onSelect();
          },
          className: styles.selectButton,
          testId: PackageCardTestIds.ViewButton(),
          disabled: disabled,
          children: "View"
        })
      })]
    })
  });
};